/**
 * @author Fernando Ruano
 * @file index.js
 * @description Profiles Container
 */

// Dependencies
import React from 'react';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Profiles Container.
 * @return { Node } React Profiles container.
 */
const ProfilesContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name Profiles.propTypes
 * @type { Object }
 */
ProfilesContainer.propTypes = {};

/**
 * Default props
 */
ProfilesContainer.defaultProps = {};

export default ProfilesContainer;
